import { z } from "zod"

export const fieldProjectionWindowV1Schema = z.enum([
  "current",
  "previous-day",
])

export type FieldProjectionWindowV1 = z.infer<
  typeof fieldProjectionWindowV1Schema
>
